import * as yup from 'yup';

import { DayLimitRecordFormValues } from '../../types';

const dayLimitArrangementSchema = (
  translate: (key: string, opts?: any) => string
) => {
  const recordSchema = yup.object({
    id: yup.string().optional(),
    fromHours: yup
      .number()
      .required()
      .min(0)
      .test(
        'lte-toHoursInclusive',
        translate('dayLimitArrangements.form.validation.fromLteTo'),
        function (value) {
          const { toHoursInclusive } = this.parent as DayLimitRecordFormValues;
          if (toHoursInclusive == null) return true;
          if (value == null) return false;
          return value <= toHoursInclusive;
        }
      ),
    toHoursInclusive: yup
      .number()
      .min(
        yup.ref('fromHours'),
        translate('dayLimitArrangements.form.validation.toGteFrom')
      )
      .transform((v, o) => (o === '' || o == null ? undefined : v))
      .optional(),
    maxNumberOfDays: yup.number().required().min(1)
  });

  return yup.object({
    claId: yup
      .number()
      .nullable()
      .transform((v, o) => (o === '' ? null : v))
      .optional(),
    validFrom: yup
      .date()
      .required()
      .typeError(
        translate('validationFieldRequired', {
          name: translate('dayLimitArrangements.form.validFrom')
        })
      ),
    validTo: yup
      .date()
      .nullable()
      .min(
        yup.ref('validFrom'),
        translate('validationNotBefore', {
          first: translate('dayLimitArrangements.form.validFrom'),
          last: translate('dayLimitArrangements.form.validTo')
        })
      )
      .transform((v, o) => (o === '' ? null : v)),
    records: yup
      .array()
      .of(recordSchema)
      .test(
        'no-overlap',
        translate('dayLimitArrangements.form.overlapError'),
        function (value) {
          if (!value || value.length <= 1) return true;
          const filteredIntervals = value
            .map((r: any) => {
              const start: number | undefined = r?.fromHours;
              const end: number | undefined =
                r?.toHoursInclusive == null
                  ? Number.MAX_SAFE_INTEGER
                  : r?.toHoursInclusive;
              return { start, end };
            })
            .filter(
              (i) => typeof i.start === 'number' && typeof i.end === 'number'
            );
          for (let i = 0; i < filteredIntervals.length; i++) {
            for (let j = i + 1; j < filteredIntervals.length; j++) {
              const a = filteredIntervals[i];
              const b = filteredIntervals[j];
              if (a.start! <= b.end! && b.start! < a.end!) {
                return false;
              }
            }
          }
          return true;
        }
      )
      .min(1, translate('dayLimitArrangements.form.noRecordsRequired'))
  });
};
export default dayLimitArrangementSchema;
